module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_data":"社員情報が登録されていません。"}}')
  delete Component.options._Ctor
}
